import { render, staticRenderFns } from "./versionUpload.vue?vue&type=template&id=145bc25f&scoped=true"
import script from "./versionUpload.vue?vue&type=script&lang=js"
export * from "./versionUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145bc25f",
  null
  
)

export default component.exports